import {SETTINGS_KEY, USER_KEY} from "@/helpers/utils";
import {
    AUTH_MUTATIONS,
    SEARCH_MUTATIONS,
    BLOG_MUTATIONS
} from './constants'

export default {
    // users
    [AUTH_MUTATIONS.UPDATE_USER](state, user) {
        state.loggedInUser = user;
        sessionStorage.setItem(USER_KEY, JSON.stringify(user));
    },
    [AUTH_MUTATIONS.UPDATE_USER_SETTINGS](state, settings) {
        state.userSettings = settings;
        sessionStorage.setItem(SETTINGS_KEY, JSON.stringify(settings));
    },
    [AUTH_MUTATIONS.USER_SETTINGS_LOADING](state, isLoading) {
        state.userSettingsLoading = isLoading;
    },
    [AUTH_MUTATIONS.UPDATE_SHAREABLE_USERS](state, userIds) {
        state.shareableIds = userIds;
    },

    // searching
    [SEARCH_MUTATIONS.SET_SEARCH_STATUS](state, status) {
        state.searchStatus = status;
    },
    [SEARCH_MUTATIONS.SET_SEARCH_RESULTS](state, results) {
        state.searchResults = results;
    },
    [SEARCH_MUTATIONS.SET_MORE_TO_LOAD](state, status) {
        state.moreToLoad = status;
    },
    [SEARCH_MUTATIONS.SET_NUM_SEARCH_RESULTS](state, numResults) {
        state.numSearchResults = numResults;
    },
    [SEARCH_MUTATIONS.REMOVE_SEARCH_RESULT](state, homeId) {
        const idx = state.searchResults.findIndex(h => h._id === homeId);
        if (idx !== -1) state.searchResults.splice(idx, 1);
    },

    // blog
    [BLOG_MUTATIONS.UPDATE_BLOG_POST_LIST](state, results) {
        state.blogPosts = results;
    },
    [BLOG_MUTATIONS.SET_BLOG_STATUS](state, status) {
        state.blogStatus = status;
    },
    [BLOG_MUTATIONS.SET_POST_TO_EDIT](state, post) {
        state.postToEdit = post;
    }
}